import React from 'react'
import Content from './content/Content';
import Header from './header/Header';
import Footer from './footer/Footer';
import Framework from 'fw/components/framework/Framework.js';
import Routes from './routes/Routes';
import * as Block from 'fw/globals/Block';

import 'css/styles.js';

class PublicLayout extends React.Component {
    componentWillMount() {
        document.body.setAttribute("class", "login-body");
    }

    render() {
        return (
            <div className="login-box wide">
                <Header />
                <Content>
                    <Framework />
                    <Block.Block ref={Block.hookref}>
                        <Routes />
                    </Block.Block>
                </Content>
                <Footer />
            </div >);
    }
}

export default PublicLayout;



// WEBPACK FOOTER //
// ./src/layouts/public/PublicLayout.js